import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { mockupUrl } from "./components/Hero";
const FONTS_HREF = "https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=Inter:wght@400;500;600;700;800&display=swap";
if (typeof document !== "undefined") {
  document.documentElement.lang = "fr";
  document.title = "Système Énergétique Tarot · Reiki · Chakras™ — La bibliothèque pratique du praticien holistique";

  // LCP: preload the hero image.
  if (!document.querySelector(`link[rel="preload"][href="${mockupUrl}"]`)) {
    const preload = document.createElement("link");
    preload.rel = "preload";
    preload.as = "image";
    preload.href = mockupUrl;
    preload.setAttribute("fetchpriority", "high");
    document.head.appendChild(preload);
  }
  for (const [href, crossOrigin] of [["https://fonts.googleapis.com", false], ["https://fonts.gstatic.com", true]] as const) {
    if (!document.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
      const preconnect = document.createElement("link");
      preconnect.rel = "preconnect";
      preconnect.href = href;
      if (crossOrigin) preconnect.crossOrigin = "anonymous";
      document.head.appendChild(preconnect);
    }
  }
  if (!document.querySelector(`link[data-google-fonts="true"]`)) {
    const fonts = document.createElement("link");
    fonts.rel = "stylesheet";
    fonts.href = FONTS_HREF;
    fonts.media = "print";
    fonts.dataset.googleFonts = "true";
    fonts.onload = () => {
      fonts.media = "all";
    };
    document.head.appendChild(fonts);
  }
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-226" data-mp="1en1wqe9noaw9" />);
}